export interface MeiucaHttpErrorDetail {
  code: string
  field?: string
  message: string
}

export interface MeiucaHttpErrorBody {
  code: string
  message: string
  status: number
  details?: MeiucaHttpErrorDetail[]
  requestId?: string
}

export class MeiucaHttpError extends Error {
  public readonly status: number
  public readonly code: string
  public readonly details?: MeiucaHttpErrorDetail[]
  public readonly requestId?: string
  public readonly response?: any
  public readonly request?: any

  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body.message)
    this.name = 'MeiucaHttpError'
    this.status = body.status
    this.code = body.code
    this.details = body.details
    this.requestId = body.requestId
    this.response = response
    this.request = request
  }
}

export class BadRequestError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'BadRequestError'
  }
}

export class UnauthorizedError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'UnauthorizedError'
  }
}

export class ForbiddenError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'ForbiddenError'
  }
}

export class NotFoundError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'NotFoundError'
  }
}

export class ValidationError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'ValidationError'
  }
}

export class RateLimitedError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'RateLimitedError'
  }
}

export class InternalError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'InternalError'
  }
}

export class ApiError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'ApiError'
  }
}

export class NetworkError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'NetworkError'
  }
}

export class UnknownError extends MeiucaHttpError {
  constructor(body: MeiucaHttpErrorBody, response?: any, request?: any) {
    super(body, response, request)
    this.name = 'UnknownError'
  }
}

// Robust 403 check: relies on `status` rather than `instanceof`, so it still
// works when the error crosses bundle boundaries (where a duplicated class
// identity would break `instanceof ForbiddenError`).
export function isForbiddenError(error: unknown): error is ForbiddenError {
  return (error as { status?: number } | null)?.status === 403
}
